import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useTheme } from '@material-ui/core/styles';

const InvestmentSummary = ({ summary = {} }) => {
  const theme = useTheme();
  const items = Array.isArray(summary.items) ? summary.items : [];
  const isIncluded = (value) => {
    const v = String(value || '').toLowerCase();
    return v === 'incluido' || v === 'incl.' || v === 'incluido*' || v === 'incl.*';
  };
  const showInvestmentColumn = items.some((row) => row.investment && !isIncluded(row.investment));

  if (items.length === 0) return null;

  return (
    <Box py={{ xs: 4, md: 6 }}>
      <Typography variant="h4" align="center" sx={{ fontWeight: 800, mb: 3 }}>
        Resumen de inversión
      </Typography>
      <TableContainer component={Paper} elevation={2} sx={{ maxWidth: 800, mx: 'auto', borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Concepto</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Detalle</TableCell>
              {showInvestmentColumn && (
                <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                  Inversión
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.detail}</TableCell>
                {showInvestmentColumn && <TableCell align="right">{row.investment}</TableCell>}
              </TableRow>
            ))}
            {summary.monthlyTotalLabel && (
              <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
                <TableCell colSpan={showInvestmentColumn ? 2 : 1} sx={{ fontWeight: 700, color: 'common.white' }}>
                  {summary.monthlyTotalLabel}
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, color: 'common.white' }}>
                  {summary.monthlyTotalValue}
                </TableCell>
              </TableRow>
            )}
            {summary.totalLabel && (
              <TableRow sx={{ bgcolor: theme.palette.primary.light }}>
                <TableCell colSpan={showInvestmentColumn ? 2 : 1} sx={{ fontWeight: 700, color: 'common.white' }}>
                  {summary.totalLabel}
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, color: 'common.white' }}>
                  {summary.totalValue}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {summary.totalNote && (
        <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 2, maxWidth: 720, mx: 'auto' }}>
          {summary.totalNote}
        </Typography>
      )}
    </Box>
  );
};

InvestmentSummary.propTypes = {
  summary: PropTypes.object,
};

export default InvestmentSummary;
